import type { ProductQuantityValidationPublicDto } from "@sticker-giant/sg-frontend-common";
import { useQuery } from "@tanstack/react-query";
import { useServicesStore } from "@/stores/useServicesStore";
export const QUANTITIES_QUERY_KEY = ["getQuantitiesForAllProducts"] as const;
const CACHE_KEY_DATA = "quantitiesForAllProducts";
const CACHE_KEY_FETCHED_ON = "quantitiesForAllProductsLastFetchedOn";
const CACHE_EXPIRY_MINUTES = 15;
const STALE_TIME_MS = 1000 * 60;
function isCacheExpired(): boolean {
  try {
    const fetchedOnTimestamp = parseInt(localStorage.getItem(CACHE_KEY_FETCHED_ON) ?? "", 10);
    if (Number.isNaN(fetchedOnTimestamp)) return true;
    const diffInMinutes = (Date.now() - fetchedOnTimestamp) / (1000 * 60);
    return diffInMinutes >= CACHE_EXPIRY_MINUTES;
  } catch {
    return true;
  }
}
export function useQuantitiesForAllProducts() {
  const productClientPublic = useServicesStore(state => state.productClientPublic);
  return useQuery<ProductQuantityValidationPublicDto[] | undefined>({
    queryKey: QUANTITIES_QUERY_KEY,
    queryFn: async () => {
      try {
        const cachedData = localStorage.getItem(CACHE_KEY_DATA);
        if (cachedData && !isCacheExpired()) {
          return JSON.parse(cachedData);
        }
      } catch {
        // skip cache
      }
      const data = await productClientPublic?.getQuantityOptionsForAllProducts(false);
      try {
        if (data) {
          localStorage.setItem(CACHE_KEY_DATA, JSON.stringify(data));
          localStorage.setItem(CACHE_KEY_FETCHED_ON, Date.now().toString());
        }
      } catch {
        // skip caching
      }
      return data;
    },
    staleTime: STALE_TIME_MS
  });
}